import { SidebarTrigger } from '@/components/ui/sidebar';
import { OrganizationName } from './OrganizationName';

export function TopBar({ children }: { children?: React.ReactNode }) {
  return (
    <header className="flex h-14 items-center gap-4 px-4 sm:px-6 sticky top-0 z-10 topbar-glass">
      <SidebarTrigger className="h-8 w-8" />
      <div className="hidden sm:block">
        <OrganizationName />
      </div>
      <div className="flex flex-1 items-center justify-end">
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </header>
  );
}
